function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Link, QuickNavigationIcons } from "@custom/schema";
import { Disclosure } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import { CheckIcon, ContactIcon, DotsIcon, DownloadIcon, EventsIcon, FAQsIcon, ProfileIcon } from "../Molecules/icons";
var _obj;
var iconsMap = (_obj = {}, _define_property(_obj, QuickNavigationIcons.Check, CheckIcon), _define_property(_obj, QuickNavigationIcons.Download, DownloadIcon), _define_property(_obj, QuickNavigationIcons.Profile, ProfileIcon), _define_property(_obj, QuickNavigationIcons.Events, EventsIcon), _define_property(_obj, QuickNavigationIcons.Faq, FAQsIcon), _define_property(_obj, QuickNavigationIcons.Contact, ContactIcon), _obj);
export var QuickNavigationMenu = function(param) {
    var quickNavigation = param.quickNavigation;
    return /*#__PURE__*/ React.createElement(Disclosure, null, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement("nav", {
            "aria-label": "Quick navigation",
            className: "hidden min-[1070px]:block"
        }, /*#__PURE__*/ React.createElement(Disclosure.Button, {
            className: "bg-green-500 rounded-l-[0.63rem] z-[9] fixed top-[9.5rem] lg:top-[13rem] right-0 focus:ring-transparent h-[4.3125rem] w-[4.1875rem] flex items-center justify-center focus-dark"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, open ? "Close quick navigation menu" : "Open quick navigation menu"), /*#__PURE__*/ React.createElement(DotsIcon, {
            "aria-hidden": "true"
        })), /*#__PURE__*/ React.createElement(AnimatePresence, {
            mode: "wait"
        }, open && /*#__PURE__*/ React.createElement(Disclosure.Panel, {
            className: "z-[8] bg-green-500 rounded-l-[0.63rem] fixed  right-0 top-[9.5rem] lg:top-[13rem]",
            as: motion.div,
            initial: "closed",
            animate: "open",
            exit: "closed",
            variants: {
                closed: {
                    height: "4.3125rem",
                    width: "4.1875rem",
                    borderTopLeftRadius: "0.63rem",
                    borderBottomLeftRadius: "0.63rem"
                },
                open: {
                    height: "auto",
                    width: "auto",
                    borderTopLeftRadius: "0.315rem",
                    borderBottomLeftRadius: "0.315rem"
                }
            },
            transition: {
                duration: 0.3,
                ease: "easeInOut",
                delay: 0.1
            },
            static: true
        }, /*#__PURE__*/ React.createElement(motion.div, {
            className: "flex flex-col gap-4 pt-10 px-4 grow pb-5",
            key: "content",
            initial: "closed",
            animate: "open",
            exit: "closed",
            variants: {
                closed: {
                    opacity: 0,
                    transition: {
                        duration: 0.1,
                        ease: "easeInOut"
                    }
                },
                open: {
                    opacity: 1,
                    transition: {
                        duration: 0.2,
                        delay: 0.35,
                        ease: "easeInOut"
                    }
                }
            }
        }, /*#__PURE__*/ React.createElement("h2", {
            className: "text-xl leading-base text-green-100 ps-3 pe-[4.75rem]"
        }, "Quick Links"), /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-col gap-1 items-start"
        }, quickNavigation.items.filter(isTruthy).map(function(item) {
            var Icon = item.icon && iconsMap[item.icon];
            return /*#__PURE__*/ React.createElement(Link, {
                key: item.title,
                href: item.target,
                className: "flex flex-row self-stretch gap-2 text-base leading-base items-center text-white py-1.5 ps-3 rounded-[0.3125rem] hover:bg-white/20  transition-all ease-in-out duration-200 group focus-white"
            }, !!Icon && /*#__PURE__*/ React.createElement(Icon, {
                className: "text-white group-hover:text-green-100 transition-all ease-in-out duration-200",
                "aria-hidden": "true"
            }), item.title);
        }))))));
    });
};
